var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Empower"},[_c('button',{on:{"click":_vm.authorize}},[_vm._v("点击授权")])])}
var staticRenderFns = []

export { render, staticRenderFns }